<template>
<div class="liveComment" v-if="commentData.length != 0">
    <div class="title-box fs-14"><span class="el-icon-s-comment tc-blue"></span><span class="tc-gray blod"> 互动评论</span></div>
    <div class="VideoFansAndComment">
        <div class="null" v-if="commentData.length == 0">
            <img src="@/common/images/leveing/video/null.png" alt="直播空">
            <p v-if="detailsList.isopencomment == 0">主播暂未收到点赞，快给主播点赞吧！</p>
            <p v-else>暂无评论</p>
        </div>
        <happy-scroll color="rgba(0,0,0,0.5)" size="5" resize @vertical-end="load" :scroll-top.sync="scrtop">
            <div class="content infinite-list">
                <!-- v-infinite-scroll="load" -->
                <template v-if="commentData.length > 0">
                    <template v-for="(item, index) in commentData">
                        <template v-if="item.ispraise == 0">
                            <div class="comment-item card flex-start flex-top" :key="index">
                                <img class="head-img" v-lazy="item.customeratturl" alt="头像">
                                <div class="msg">
                                    <div class="title flex-between">
                                        <span class="tc-black" style="margin-bottom: 6px;">{{item.customername}}</span>
                                        <span>{{ item.datetime }}</span>
                                    </div>
                                    <div class="txt">
                                        <p class="fs-12 tc-black">{{ item.content }}</p>
                                    </div>
                                </div>
                            </div>
                            <!-- end 评论 -->
                        </template>
                        <template v-if="item.ispraise == 1">
                            <div class="fans-item card" :key="index">
                                <img class="head-img" v-lazy="item.customeratturl" alt="头像">
                                <div class="msg">
                                    <div class="title">
                                        <span>{{ item.customername }}</span>
                                        <span>{{ item.datetime }}</span>
                                    </div>
                                    <div class="txt">
                                        <p>给主播点了赞 <img src="@/common/images/leveing/video/love.png" alt="喜欢"></p>
                                    </div>
                                </div>
                            </div>
                            <!-- end 点赞 -->
                        </template>
                    </template>
                </template>
            </div>
        </happy-scroll>
        <template v-if="detailsList.isopencomment == 1">
            <div class="comment-btn flex-between">
                <div class="flex-between comment_box" v-if="user.isLogin">
                    <el-input placeholder="快来讨论一下吧～" v-model="commentTxt"></el-input>
                    <el-button type="primary" @click="addComment" :disabled="commentTxt.length == 0">发送</el-button>
                </div>
                <el-button v-else type="primary" class="login-btn" @click="clickLoadingPopu">快快登录参与评论吧～</el-button>
            </div>
        </template>
    </div>
</div>
</template>

<script>
import Vue from 'vue'
import infiniteScroll from 'vue-infinite-scroll'
import {HappyScroll} from 'vue-happy-scroll'
import {getLiveCommentList, getLiveNewCommentList, addCommentInfo} from 'api/pcvideo.js'
import {mapActions, mapGetters} from 'vuex'
import 'vue-happy-scroll/docs/happy-scroll.css'

Vue.use(infiniteScroll)
export default {
name: 'liveComment',
props: ['detailsList'],
data() {
  return {
    innerid: this.$route.query.innerid, // 编号
    commentTxt: '',  // 讨论
    loveStatus: false, // 点赞状态
    videohead: true, // 封面显示
    timingGetCommentStatusCode: false,
    timingGetCommentStatus: '', // 定时评论参数
    commentData: [],  // 评论
    scrtop: 0,  // 滚动条具体顶部位置
    times: 0  // 倒计时时间 评论完毕后，5s内不能再次评论
  }
},
mounted() {
  // 获取最新历史评论
  this.$nextTick(() => {
    this.getInfiniteScrollComment(-1)
  })
  // 定时获取评论
  this.timingGetComment()
},
methods: {
  getInfiniteScrollComment(minmsgid) { // 获取下拉刷新历史评论
    if (this.detailsList.isopencomment !== undefined) {
      // this.setLoading(true)
      getLiveCommentList({
        data: {
          kmcinnerid: this.innerid,
          minmsgid: minmsgid,
          pageSize: 10,
          isopencomment: this.detailsList.isopencomment
        },
        success: data => {

          // this.setLoading(false)
          if (this.commentData.length == 0) {
            this.commentData = data.data.commentinfo
          } else {
            this.commentData = this.commentData.concat(data.data.commentinfo)
          }

          this.$nextTick(() => {
            this.timingGetComment()
          })
        },
        error: data => {
          // this.setLoading(false)
          this.timingGetComment()
          this.$message.error(data.msg)
        }
      })
    }
  },
  getNewComment(maxmsgid) { // 获取最新评论
    if (this.detailsList.isopencomment !== undefined) {
      getLiveNewCommentList({
        data: {kmcinnerid: this.innerid, maxmsgid: maxmsgid, isopencomment: this.detailsList.isopencomment},
        success: data => {
          this.setLoading(false)
          if (this.commentData.length == 0) {
            this.commentData = data.data.commentinfo
          } else {
            this.commentData = data.data.commentinfo.concat(this.commentData)
          }
          this.$nextTick(() => {
            this.timingGetComment()
          })
          // console.log(data.data)
        },
        error: data => {
          this.setLoading(false)
          this.timingGetComment()
          this.$message.error(data.msg)
        }
      })
    }
  },
  addComment() {  // 发布评论
    if (this.times > 0) {
      this.$message.warning('请勿频繁评论')
      return
    }
    this.setLoading(true)
    // 发布评论时暂停定时获取评论器
    this._clearIntervalComment()
    addCommentInfo({
      data: {kmcinnerid: this.innerid, content: this.commentTxt},
      success: data => {
        this.setLoading(false)
        if (data.code == '000') {
          if (this.detailsList.iscommentaudit == 1) {
            this.$message.success('您的评论正在审核中')
          } else {
            this.$message.success('评论成功')
          }
          this.commentTxt = ""
          this.times = 5
          let intevalTimes = setInterval(() => {
            if (this.times == 0) {
              clearInterval(intevalTimes)
            }
            this.times -= 1
          }, 1000)
          // 获取评论
          this._getNewComment()
          this.scrtop = 0
        }
      },
      error: data => {
        this.setLoading(false)
        this.$message.error(data.msg)
      }
    })
  },
  load() { // 下拉加载
    // 通过最小comid 取得历史记录
    if (this.commentData.length > 0) {
      // 下拉加载时关闭轮询
      this._clearIntervalComment()
      this.getInfiniteScrollComment(this.commentData[this.commentData.length - 1].comid)
    }
  },
  timingGetComment() {  // 定时获取评论
    // 每20秒获取一次最新评论 评论不存在时，默认获取-1
    if (this.timingGetCommentStatusCode == false) {
      this.timingGetCommentStatusCode = true
      this.timingGetCommentStatus = setInterval(() => {
        this._getNewComment()
      }, 20000)
    }
  },
  clickLoadingPopu() {  // 打开登录弹窗
    this.setLoginPop(true)
  },
  _getNewComment() {  // 获取评论
    if (this.commentData.length == 0) {
      this.getNewComment(-1)
    } else {
      this.getNewComment(this.commentData[0].comid)
    }
  },
  _clearIntervalComment() { // 关闭轮询评论
    this.timingGetCommentStatusCode = false
    clearInterval(this.timingGetCommentStatus)
  },
  ...mapActions(['setLoading', 'setLoginPop'])
},
filters: {},
watch: {},
computed: {
  ...mapGetters(['loginPop', 'user', 'domainInfo'])
},
components: {
  HappyScroll
}
}
</script>

<style lang="scss" type="text/scss">
.liveComment {
    width: 320px;
    margin-bottom: 20px;
    height: 480px;
    box-sizing: border-box;
    border-radius:0 16px 16px 0;
    background: #fff;
    padding: 15px 10px 0 20px;
    .title-box{
        background: #fff;
        height: 22px;
    }
    .mCSB_inside > .mCSB_container {
        margin-right: 0;
    }
    .VideoFansAndComment {
        padding: 0 0 56px 0;
        box-sizing: border-box;
        height: calc(100% - 22px);
        position: relative;
        .happy-scroll{
            .happy-scroll-container{
                height: 100% !important;
                width: 100% !important;
            }
            .happy-scroll-content{
                width: calc(100% - 20px);
            }
        }
        .comment-btn {
            position: absolute;
            padding: 0;
            height: 56px;
            left: 0px;
            right: 10px;
            bottom: 0;
            background: #fff;
            .comment_box {
                width: 100%;
            }
            .el-input {
                width: 220px;
                .el-input__inner {
                    height: 30px;
                    line-height: 30px;
                    font-size: 12px;
                }
            }
            .el-button {
                width: 50px;
                height: 30px;
                padding: 0;
                font-size: 12px;
            }
            .login-btn{
                width: 100%;
                height: 30px;
                line-height: 30px;
                background: #409EFF;
                border-radius: 4px;
                font-size: 12px;
                color: #fff;
            }
        }
    }
    .content {
        overflow-y: auto;
        height: calc(100% - 75px);
        .fans-item {
            display: flex;
            .msg {
                .title {
                    display: flex;
                    justify-content: space-between;
                }
            }
        }
        .card {
            padding: 10px 0;
            overflow: hidden;
            .head-img {
                background: #ccc;
            }
            .head-img,
            .msg {
                &.head-img {
                    width: 40px;
                    min-width: 40px;
                    height: 40px;
                    border-radius: 50%;
                }
                &.msg {
                    margin-left: 10px;
                    width: 220px;
                    .title {
                        margin-top: 4px;
                        overflow: hidden;
                        span {
                            font-size: 14px;
                            & ~ span {
                                font-size: 12px;
                                color: #999;
                            }
                        }
                    }
                    .txt {
                        margin-top: 4px;
                        p {
                            font-size: 12px;
                            line-height: 18px;
                        }
                        img {
                            display: inline-block;
                            width: 14px;
                            height: 12px;
                            transform: translateY(1px);
                            -webkit-transform: translateY(1px);
                            -ms-transform: translateY(1px);
                            -o-transform: translateY(1px);
                            -moz-transform: translateY(1px);
                        }
                    }
                }
            }
        }
    }
    .null {
        padding-top: 133px;
        img {
            display: block;
            margin: auto;
            width: 127px;
            height: 120px;
        }
        p {
            margin-top: 20px;
            font-size: 12px;
            color: #999;
            text-align: center;
        }
    }
}
</style>
<style lang="scss">
.liveComment {
    --bubble_time: 3s;
    --bubble_scale: 0.8s;
    .praise_bubble {
        width: 100px;
        height: 200px;
        position: absolute;
        z-index: 4;
        right: 20px;
        bottom: 100px;
    }
    .bubble {
        position: absolute;
        width: 40px;
        height: 40px;
        left: 30px;
        bottom: 0px;
        background-repeat: no-repeat;
        background-size: 100%;
        transform-origin: bottom;
    }
    .b1 {
        background-image: url('./../../../../common/images/leveing/video/bg1.png');
        // 可以使用雪碧图
        // background-position: -42px -107px;
        // background-size: 188.5px 147px;
    }
    .b2 {
        background-image: url('./../../../../common/images/leveing/video/bg2.png');
        // background-position: -84px -107px;
        // background-size: 188.5px 147px;
    }
    .b3 {
        background-image: url('./../../../../common/images/leveing/video/bg3.png');
        // background-position: 0 -107px;
        // background-size: 188.5px 147px;
    }
    .b4 {
        background-image: url('./../../../../common/images/leveing/video/bg4.png');
        // background-position: -45px -62px;
        // background-size: 188.5px 147px;
    }
    .b5 {
        background-image: url('./../../../../common/images/leveing/video/bg5.png');
        // background-position: -107px -42px;
        // background-size: 188.5px 147px;
    }
    .b6 {
        background-image: url('./../../../../common/images/leveing/video/bg6.png');
        // background-position: -107px 0;
        // background-size: 188.5px 147px;
    }
    .bl1 {
        animation: bubble_1 var(--bubble_time) linear 1 forwards,
        bubble_big_1 var(--bubble_scale) linear 1 forwards,
        bubble_y var(--bubble_time) linear 1 forwards;
    }
    .bl2 {
        animation: bubble_2 var(--bubble_time) linear 1 forwards,
        bubble_big_2 var(--bubble_scale) linear 1 forwards,
        bubble_y var(--bubble_time) linear 1 forwards;
    }
    .bl3 {
        animation: bubble_3 var(--bubble_time) linear 1 forwards,
        bubble_big_1 var(--bubble_scale) linear 1 forwards,
        bubble_y var(--bubble_time) linear 1 forwards;
    }
    .bl4 {
        animation: bubble_4 var(--bubble_time) linear 1 forwards,
        bubble_big_2 var(--bubble_scale) linear 1 forwards,
        bubble_y var(--bubble_time) linear 1 forwards;
    }
    .bl5 {
        animation: bubble_5 var(--bubble_time) linear 1 forwards,
        bubble_big_1 var(--bubble_scale) linear 1 forwards,
        bubble_y var(--bubble_time) linear 1 forwards;
    }
    .bl6 {
        animation: bubble_6 var(--bubble_time) linear 1 forwards,
        bubble_big_3 var(--bubble_scale) linear 1 forwards,
        bubble_y var(--bubble_time) linear 1 forwards;
    }
    .bl7 {
        animation: bubble_7 var(--bubble_time) linear 1 forwards,
        bubble_big_1 var(--bubble_scale) linear 1 forwards,
        bubble_y var(--bubble_time) linear 1 forwards;
    }
    .bl8 {
        animation: bubble_8 var(--bubble_time) linear 1 forwards,
        bubble_big_3 var(--bubble_scale) linear 1 forwards,
        bubble_y var(--bubble_time) linear 1 forwards;
    }
    .bl9 {
        animation: bubble_9 var(--bubble_time) linear 1 forwards,
        bubble_big_2 var(--bubble_scale) linear 1 forwards,
        bubble_y var(--bubble_time) linear 1 forwards;
    }
    .bl10 {
        animation: bubble_10 var(--bubble_time) linear 1 forwards,
        bubble_big_1 var(--bubble_scale) linear 1 forwards,
        bubble_y var(--bubble_time) linear 1 forwards;
    }
    .bl11 {
        animation: bubble_11 var(--bubble_time) linear 1 forwards,
        bubble_big_2 var(--bubble_scale) linear 1 forwards,
        bubble_y var(--bubble_time) linear 1 forwards;
    }
    @keyframes bubble_11 {
        0% {
        }
        25% {
            margin-left: -10px;
        }
        50% {
            margin-left: -10px;
        }
        100% {
            margin-left: -18px;
        }
    }
    @keyframes bubble_10 {
        0% {
        }
        25% {
            margin-left: -20px;
        }
        50% {
            margin-left: -20px;
        }
        100% {
            margin-left: -20px;
        }
    }
    @keyframes bubble_9 {
        0% {
        }
        25% {
            margin-left: 10px;
        }
        50% {
            margin-left: 10px;
        }
        100% {
            margin-left: 10px;
        }
    }
    @keyframes bubble_8 {
        0% {
        }
        25% {
            margin-left: 20px;
        }
        50% {
            margin-left: 20px;
        }
        100% {
            margin-left: 20px;
        }
    }
    @keyframes bubble_7 {
        0% {
        }
        25% {
            margin-left: 3px;
        }
        50% {
            margin-left: 1px;
        }
        75% {
            margin-left: 2px;
        }
        100% {
            margin-left: 3px;
        }
    }
    @keyframes bubble_6 {
        0% {
        }
        25% {
            margin-left: -3px;
        }
        50% {
            margin-left: -1px;
        }
        75% {
            margin-left: -2px;
        }
        100% {
            margin-left: -3px;
        }
    }
    @keyframes bubble_5 {
        0% {
        }
        25% {
            margin-left: 5px;
        }
        50% {
            margin-left: -5px;
        }
        75% {
            margin-left: -10px;
        }
        100% {
            margin-left: -20px;
        }
    }
    @keyframes bubble_4 {
        0% {
        }
        25% {
            margin-left: -5px;
        }
        50% {
            margin-left: -5px;
        }
        75% {
            margin-left: 20px;
        }
        100% {
            margin-left: 10px;
        }
    }
    @keyframes bubble_3 {
        0% {
        }
        25% {
            margin-left: -20px;
        }
        50% {
            margin-left: 10px;
        }
        75% {
            margin-left: 20px;
        }
        100% {
            margin-left: -10px;
        }
    }
    @keyframes bubble_2 {
        0% {
        }
        25% {
            margin-left: 20px;
        }
        50% {
            margin-left: 25px;
        }
        75% {
            margin-left: 10px;
        }
        100% {
            margin-left: 5px;
        }
    }
    @keyframes bubble_1 {
        0% {
        }
        25% {
            margin-left: -8px;
        }
        50% {
            margin-left: 8px;
        }
        75% {
            margin-left: -15px;
        }
        100% {
            margin-left: 15px;
        }
    }
    @keyframes bubble_big_1 {
        0% {
            transform: scale(0.3);
        }
        100% {
            transform: scale(1.2);
        }
    }
    @keyframes bubble_big_2 {
        0% {
            transform: scale(0.3);
        }
        100% {
            transform: scale(0.9);
        }
    }
    @keyframes bubble_big_3 {
        0% {
            transform: scale(0.3);
        }
        100% {
            transform: scale(0.6);
        }
    }
    @keyframes bubble_y {
        0% {
            margin-bottom: 0;
        }
        10% {
            margin-bottom: 0;
        }
        75% {
            opacity: 1;
        }
        100% {
            margin-bottom: 200px;
            opacity: 0;
        }
    }
}
</style>